<template>
  <div class="pages">

    <!-- 移动端 -->
    <div :class="[ismobile ? '' : 'none']"
         class="img1"
         :style="{ 'height': height + 'px' }">
      <div class="top">
        <img v-if="status"
             src="../image/downloadImg_5.png"
             alt="">
        <img v-else
             src="../image/downloadImg_5_1.png"
             alt="">
      </div>
      <div class="center">
        <span>“掌上单一窗口”</span>
        是
        <span>“中国国际贸易单一窗口”</span>
        标准版在移动端的统一查询和办事的公共服务平台，由国家口岸管理办公室主办，中国电子口岸数据中心负责建设和运行维护，于2020年5月1日正式上线运行。
      </div>
      <!-- 如果是微信内置浏览器显示蒙板 -->
      <div class="mengban"
           :class="[ismobile && isweiXin ? '' : 'none']">
        <img src="../image/downloadImg_22.png"
             alt="">
      </div>
      <!-- 不是微信内置浏览器 -->
      <div class="bottom"
           :class="[downloads && !loading && !isweiXin ? '' : 'none']">
        <div>软件安装中，请在桌面查看</div>
        <div>内测软件，需手动设置信任证书</div>
        <div class="btn"
             @click="opentrust">
          立即前往
        </div>
      </div>
      <!-- 立即下载 -->
      <div class="bottoms"
           :class="[!downloads && !loading && !isweiXin ? '' : 'none']"
           @click="openApp">
        <div class="btn">
          <img src="../image/downloadImg_23.png"
               alt="">
          立即下载
        </div>
      </div>
      <!-- 动画 -->
      <div class="loading"
           :class="[ loading && !isweiXin ? '' : 'none']"
           @click="download">
        <img src="../image/loading.gif"
             alt="">
      </div>
    </div>

    <!-- 是pc端 -->
    <div :class="[!ismobile ? '' : 'none']"
         class="img3">
      <img class="img3_img"
           src="../image/downloadImg_1.jpg"
           alt="">
      <div class="logo">
        <img v-if="status"
             src="../image/downloadImg_5.png"
             alt="">
        <img v-else
             src="../image/downloadImg_5_1.png"
             alt="">
        <span>掌上单一窗口</span>
      </div>
      <div class="qrcodeOut">
        <div id="qrcode"></div>
        <div class="qrcodeOut_text">请使用手机扫描二维码</div>
        <div class="qrcodeOut_text">下载APP体验</div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { Sticky } from 'vant'


import sdk from '@/views/js/sdk'


export default {
  name: 'downloadapp',
  components: {
    [Sticky.name]: Sticky
  },

  data () {
    return {
      height: window.innerHeight,
      status: false,    //判断是正式环境还是测试环境
      loading: false,  //判断是否显示动画
      isandriod: false, //判断是andriod还是ios
      ismobile: false,  //判断是移动端还是pc端
      isweiXin: false,  //判断是否是微信内置浏览器
      downloads: false, //ios判断段是否点击下载
      retData: {}
    }
  },
  /**
   * 初始化
   */
  mounted () {
    //是否是移动端
    if (this.isMobile()) {
      this.ismobile = true
    } else {
      this.ismobile = false
    }
    // 是否是微信内置浏览器
    if (this.isWeiXin()) {
      this.isweiXin = true
      //微信分享
      let url = location.href.split('#')[0];
      url = url.replace('/#/', '/?#/');
      let linkurl = location.href
      this.judge ()
      if (this.status) {
        //微信分享需要的参数
        var dataForWeixin = {
          //分享标题
          title: '掌上单一窗口下载页',
          //分享内容
          desc: "“掌上单一窗口”是“中国国际贸易单一窗口”标准版在移动的统一查询和办事的公共…",
          //分享链接
          linkurl: linkurl,
          //分享内容显示的图片(图片必须是正方形的链接)
          img: 'https://app.singlewindow.cn/zsdyckserver/myapp/dist/img/downloadImg_5.26266ea1.png',
        };
      } else {
        var dataForWeixin = {
          //分享标题
          title: '掌上单一窗口(测试版)下载页',
          //分享内容
          desc: "“掌上单一窗口”是“中国国际贸易单一窗口”标准版在移动的统一查询和办事的公共…",
          //分享链接
          linkurl: linkurl,
          //分享内容显示的图片(图片必须是正方形的链接)
          img: 'https://apptest.singlewindow.cn/zsdyckserver/myapp/dist/img/downloadImg_5_1.d6e745d5.png',
        };
      }

      //传入微信分享需要的参数
      sdk.getJSSDK(url, dataForWeixin);
    } else {
      this.isweiXin = false
    }
    //是ios还是andriod
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS) {
      this.isandriod = false
    } else {
      this.isandriod = true
    }
    this.qrcode()
    this.getData()
    this.judge()
    window.addEventListener('resize', () => {
      this.qrcode();
      this.height = window.innerHeight
    })
  },

  methods: {
    //下载&跳转app
   openApp(){
    console.log("openApp")
    var iOSUrl = "asinglewindow://";//填URL Schemes

    var u = navigator.userAgent;
    var isIOS = !!u.match(/\i[^;]+;(U;)? CPU.+Mac OS X/);

    //判断是否是iOS
    if(isIOS){
      window.location.href = "https://apps.apple.com/cn/app/id1053012308";//填下载App落地页
    }else{
       window.location.href = this.retData.AN_URL
    }
    },

    //判断当前是正式域名还是测试域名
    judge () {
      let str = window.location.href
      let index = str.indexOf("app.singlewindow.cn")
      let index1 = str.indexOf("swapp.singlewindow.cn")
      let index2 = str.indexOf("apptrain.singlewindow.cn")
      if (index > -1 || index1 > -1 || index2 > -1) {
        this.status = true
      } else {
        this.status = false
      }
    },
    //获取页面下载所需数据
    getData () {
      this.$http1
        .get("/zsdyckserver/app/getAppVer", {})
        .then(res => {
          this.retData = res.retData
        })
    },
    //ios受信任
    opentrust () {
      window.location.href = this.retData.IOS_DOWNLOAD + "embedded.mobileprovision"
    },
    //点击下载
    download () {
      this.loading = true
      if (this.isandriod) {
        window.location.href = this.retData.AN_URL
      } else {
        window.location.href = "itms-services://?action=download-manifest&url=" + this.retData.IOS_DOWNLOAD + "zsdyck.plist"
        setTimeout(() => {
          this.downloads = true
          this.loading = false
        }, 3200)
      }
    },
    // 判断是移动端还是pc端
    isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    //判断是否是微信内置浏览器
    isWeiXin () {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true; // 是微信端
      } else {
        return false;
      }
    },
    //生成二维码(pc端)
    qrcode () {
      document.getElementById('qrcode').innerHTML = ''
      console.log(document.documentElement.clientWidth)
      let width = document.documentElement.clientWidth * 0.17;
      let height = document.documentElement.clientWidth * 0.17;
      let qrcode = new QRCode('qrcode', {
        width: width,
        height: height,
        colorDark: "#000",
        colorLight: "#fff",
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H
      })
      qrcode.clear() //清除二维码 
      qrcode.makeCode(window.location.href)
    },
  },
}
</script>

<style scoped lang="scss">
.pages {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  position: relative;
}
.img1 {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 375px;
  // height: 100vh;
  background: url("../image/downloadImg_21.jpg") no-repeat;
  // border: 1px solid red;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding-top: 40px;
  .top {
    > img {
      width: 84px;
      height: 84px;
      margin: auto;
      display: block;
    }
  }
  .center {
    text-indent: 28px;
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 400;
    color: rgba(5, 15, 40, 1);
    line-height: 28px;
    font-family: PingFang SC;
    margin-top: 38px;
    span {
      font-weight: 600;
    }
  }
  .mengban {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100vh;
    background: rgba($color: #040b1d, $alpha: 0.8);
    img {
      width: 100%;
    }
  }
  .bottom {
    width: 100%;
    position: absolute;
    bottom: 41px;
    > div:first-child {
      text-align: center;
      color: #ff7f00;
      font-size: 16px;
      font-weight: 600;
    }
    > div:nth-child(2) {
      text-align: center;
      color: #050f28;
      font-size: 10px;
      margin-top: 10px;
    }
    .btn {
      width: 158px;
      height: 50px;
      line-height: 50px;
      margin: auto;
      margin-top: 20px;
      text-align: center;
      background: rgba(255, 127, 0, 1);
      border-radius: 25px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(254, 254, 254, 1);
    }
  }
  .bottoms {
    width: 100%;
    position: absolute;
    bottom: 41px;
    .btn {
      width: 158px;
      height: 50px;
      line-height: 50px;
      margin: auto;
      margin-top: 20px;
      background: rgba(255, 127, 0, 1);
      border-radius: 25px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(254, 254, 254, 1);
      img {
        width: 20px;
        height: 18px;
        float: left;
        margin: 18px 10px 0 35px;
      }
    }
  }
  .loading {
    position: absolute;
    bottom: 41px;
    width: 100%;
    img {
      margin: auto;
      display: block;
      width: 48px;
      height: 48px;
    }
  }
}
// .img2{
//   width: 375px;
//   height: 100%;
//   min-height: 100vh;
//   background: url("../image/downloadImg_3.jpg") no-repeat;
//   background-size: 100% 100%;
// }
// .img2_1{
//    width: 375px;
//   height: 100%;
//   min-height: 100vh;
//   background: url("../image/downloadImg_4.jpg") no-repeat;
//   background-size: 100% 100%;
// }
.img3 {
  height: 100%;
  .logo {
    height: 50px;
    line-height: 50px;
    position: absolute;
    top: 15px;
    left: 16px;
    > img {
      width: 50px;
      height: 50px;
      float: left;
    }
    > span {
      font-size: 18px;
      font-weight: 600;
      color: #000000;
      margin-left: 10px;
    }
  }
}
.img3_img {
  width: 100%;
  height: 100%;
}
.qrcodeOut {
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  // width: 160px;
  transform: translate(-55%, -50%);
  #qrcode {
    margin: auto;
    box-sizing: border-box;
    background: #ffffff;
    padding: 10px;
    border: 1px solid #e6e6ea;
    border-radius: 2px;
    img {
      margin: auto;
    }
  }
  > div:nth-child(2) {
    margin-top: 11px;
  }
  .qrcodeOut_text {
    text-align: center;
    font-size: 10px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(5, 15, 40, 1);
    line-height: 18px;
  }
}

.none {
  display: none;
}
</style>

